/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { isEmpty, orderBy, cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TopProductAttributeTable from './TopProductAttributeTable';
import BottomProductAttributesTable from './BottomProductAttributesTable';
import FilterBy from '../../../Components/Utility/FilterAction/FilterBy';
import DeletePopup from '../../../Components/ModalPopup/DeletePopup';
import * as devAction from '../store/DevelopmentOrder.action';
import * as action from './store/product.action';
import * as bomLibAction from '../../Library/BomLibrary/store/BomLibrary.action';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import * as supplierAction from '../../Supplier/store/Supplier.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import ProductFilter from '../../../Components/ProductFilter/ProductFilter';
import { checkArray, Page_Size } from '../../../Components/helper';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import './ProductBomModal.css';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function ProductAttributes({ onOpen, toggleProdReq, showDatas, fromBomLib }) {
  const showData = cloneDeep(showDatas);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets, ProductAttributeDetails, UserDetails, BomLibraryDetails, SystemMastersDetails } = ProductTestingData;
  const { productRefs } = Measuremets;
  const { userInfo } = UserDetails;
  const { listofProducts, totalcount } = ProductAttributeDetails;
  const { Composition } = BomLibraryDetails;
  const { subBrandAccess } = SystemMastersDetails;
  const loggedInUserId = userInfo.userId;

  const [isSelectAll, setIsSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [showDeleteConfirmationPopup, setShowDeleteConfirmationPopup] = useState(false);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [showNewRow, setShowNewRow] = useState(false);
  const [searchLoaded, setSearchLoaded] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCategory1, setSelectedCategory1] = useState(null);
  const [selectedCategory2, setSelectedCategory2] = useState(null);
  const [selectedCategory3, setSelectedCategory3] = useState(null);
  const [selectedCategory4, setSelectedCategory4] = useState(null);
  const [selectedColourWay, setSelectedColourWay] = useState(null);
  const [selectedColour, setSelectedColour] = useState(null);
  const [indexes, setIndexes] = useState([]);
  const [parentIndexes, setParentIndexes] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [sortedData, setSortedData] = useState([]);
  const [topSelectedColour, settopSelectedColour] = useState(null);
  const [topSelectedSupplier, settopSelectedSupplier] = useState(null);
  const [topSelectedComponentSupplier, settopSelectedComponentSupplier] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [count, setCount] = useState(0);
  const [topcolourWayRefsData, setTopColourWayrefData] = useState({
    colourRef: '',
    colourConfirmationRef: '',
  });
  const [state, setState] = useState({
    pageIndex: 1,
    pageSize: Page_Size,
    isScrollLoader: false,
    hasMore: false,
    filterParams: null,
    sortBy: null,
    search: '',
  });

  const [sortTable, setSortTable] = useState({
    sortOrder: '',
    sortPropertyName: '',
  });
  const [isProductFilter, setIsProductFilter] = useState(false);

  const [disabledBtn, setDisabledBtn] = useState(false);

  const singleColourMultipleSuppliers = (objs) => {
    let tempObject = {};
    const expandingData = [];
    objs?.suppliers?.forEach((suppEle) => {
      tempObject = {
        ...objs,
        supplier: [suppEle],
        colour: objs?.colourLibraries,
        componentSupp: objs.componentSupp && Array.isArray(objs.componentSupp) && objs.componentSupp.length > 0 ? objs.componentSupp : [],
        idPlusSupplierId: objs?._id + suppEle?._id + objs?.colourLibraries?.[0]?._id,
      };
      expandingData.push(tempObject);
    });
    objs.expandData = [...expandingData];
  };

  const singleSupplierWithMultiplerColours = (objs) => {
    let tempObject = {};
    const expandingData = [];
    objs?.colourLibraries?.forEach((colorEle) => {
      tempObject = {
        ...objs,
        colour: [colorEle],
        supplier: objs?.suppliers,
        componentSupp: objs.componentSupp && Array.isArray(objs.componentSupp) && objs.componentSupp.length > 0 ? objs.componentSupp : [],
        idPlusSupplierId: objs?._id + colorEle?._id + objs?.suppliers?.[0]?._id,
      };
      expandingData.push(tempObject);
    });
    objs.expandData = [...expandingData];
  };

  useEffect(() => {
    const fetchSubbrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    fetchSubbrandAccess();
  }, []);

  useEffect(() => {
    const copyState = cloneDeep(listofProducts);
    copyState?.forEach((ele) => {
      if (ele?.suppliers?.length === 0 && ele?.colourLibraries?.length === 0) {
        ele.idPlusSupplierId = ele?._id;
        ele.expandData = [];
      } else if (ele?.suppliers?.length > 1 && ele?.colourLibraries?.length < 1) {
        ele.idPlusSupplierId = ele._id + (ele?.suppliers?.[0]?._id || '');
        ele.expandData = [];
      } else if (
        ele?.suppliers?.length > 1 &&
        ele?.colourLibraries?.length > 1 &&
        (showData?.combinationSuppliers?.length === 0 || !showData?.combinationSuppliers)
      ) {
        let tempObject = {};
        const expandingData = [];
        ele?.suppliers?.forEach((suppElement) => {
          ele?.colourLibraries?.forEach((colourElement) => {
            tempObject = {
              ...ele,
              supplier: [suppElement],
              colour: [colourElement],
              idPlusSupplierId: ele?._id + suppElement?._id + colourElement?._id,
              // componentSupp: showData?.BOMSupplier?.[0]?.name,
              componentSupp: ele.componentSupp && Array.isArray(ele.componentSupp) && ele.componentSupp.length > 0 ? ele.componentSupp : [],
            };
            expandingData.push(tempObject);
          });
        });
        ele.expandData = [...expandingData];
      } else if (showData?.combinationSuppliers?.length >= 1 && ele?.suppliers?.length > 1 && ele?.colourLibraries?.length > 1) {
        let tempObject = {};
        const expandingData = [];
        ele?.suppliers?.forEach((suppElement) => {
          ele?.colourLibraries?.forEach((colourElement) => {
            showData?.combinationSuppliers?.forEach((combSup) => {
              if (combSup?.componentSupplier?._id === ele?.componentSupp?.[0]?._id) {
                tempObject = {
                  ...ele,
                  supplier: [suppElement],
                  colour: [colourElement],
                  componentSupp: combSup?.componentSupplier?.name,
                  idPlusSupplierId: ele?._id + suppElement?._id + colourElement?._id,
                };
                expandingData.push(tempObject);
              }
            });
          });
        });
        ele.expandData = [...expandingData];
      } else if (ele?.suppliers?.length > 1 && ele?.colourLibraries?.length <= 1) {
        singleColourMultipleSuppliers(ele);
      } else {
        singleSupplierWithMultiplerColours(ele);
      }
    });
    setParentIndexes([]);
    setIndexes([]);
    if (isSelectAll && !isEmpty(copyState)) {
      const selectedItems = [];
      for (const item of copyState) {
        let findItems = [];
        findItems = ifMoreSuppliers(item, selectedItems);
        if (isEmpty(findItems)) {
          selectedItems.push(...forExpandData(item));
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setAllProducts([...copyState]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listofProducts]);

  useEffect(() => {
    if (!isEmpty(allProducts)) {
      let c = 0;
      allProducts.forEach((ele) => {
        if (ele?.expandData?.length > 1) {
          c += 1;
        }
      });
      setCount(c);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allProducts]);

  useEffect(() => {
    if (!isEmpty(sortedData)) {
      const TempState = cloneDeep(sortedData);
      TempState?.forEach((object) => {
        if (object?.suppliers?.length > 1 && object?.colourLibraries?.length <= 1) {
          object.idPlusSupplierId = object._id + object?.suppliers?.[0]?._id + object?.colourLibraries?.[0]?._id;
          singleColourMultipleSuppliers(object);
        } else if (object?.suppliers?.length > 1 && object?.colourLibraries?.length > 1) {
          let tempObject = {};
          const expandingData = [];
          object?.suppliers?.forEach((suppElement) => {
            object?.colourLibraries?.forEach((colourElement) => {
              tempObject = {
                ...object,
                supplier: [suppElement],
                colour: [colourElement],
                idPlusSupplierId: object?._id + suppElement?._id + colourElement?._id,
              };
              expandingData.push(tempObject);
            });
          });
          object.expandData = [...expandingData];
        } else {
          singleSupplierWithMultiplerColours(object);
        }
      });
      setAllProducts([...TempState]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedData, listofProducts?.length]);

  useEffect(() => {
    const initialExicution = async () => {
      try {
        setLoading(true);
        const res = await dispatch(
          action.getAllUsageProducts({
            bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
            isBomLibrary: !!fromBomLib,
            pageIndex: 1,
            pageSize: Page_Size,
          }),
        );
        res && setLoading(false);
        const brandParams = {
          accessedFrom: '',
          loggedInUserId,
        };
        const psParams = {
          loggedInUserId,
        };

        Promise.all([
          dispatch(systemMasterAction.getBrandDetails(brandParams)),
          dispatch(systemMasterAction.getSeasonsDetails({ loggedInUserId, isActive: true })),
          dispatch(devAction.colourProductTesting({ loggedInUserId, isActive: true })),
          dispatch(systemMasterAction.getAllUnitDetails({ loggedInUserId, isActive: true })),
          dispatch(systemMasterAction.getProductStatusDetails(psParams)),
          dispatch(bomLibAction.fetchBomReferenceType({ bomTypeId: showData?.bomType?._id })),
          dispatch(supplierAction.fetchTier1SupplierListAction()),
          dispatch(supplierAction.fetchTier2AboveSupplierListAction()),
          dispatch(
            bomLibAction.fetchBomLibarayComposition({
              isActive: 1,
              loggedInUserId: userInfo.userId,
              bomTypeId: showData?.bomType?._id,
            }),
          ),
        ]);
      } catch (e) {
        console.log('get Api error In product Attribute', e.toString());
      }
    };
    initialExicution();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ForCategoryThree = (c1, c2) => {
    setSelectedCategory3('Select Category3');
    const cat3params = {
      categoryOneId: c1,
      categoryTwoId: c2,
      categoryType: 3,
      loggedInUserId,
    };
    dispatch(systemMasterAction.getCategory3Details(cat3params, false));
  };
  const ForCategoryFour = async (c1, c2, c3) => {
    setSelectedCategory4('Select Category4');

    const cat4params = {
      categoryOneId: c1,
      categoryTwoId: c2,
      categoryThreeId: c3,
      categoryType: 4,
      loggedInUserId,
    };
    dispatch(systemMasterAction.getCategory4Details(cat4params));
  };

  const onSubmitFilter = async (filterParams) => {
    setLoading(true);
    const params = {
      bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: !!fromBomLib,
      ...filterParams,
      pageIndex: 1,
      pageSize: Page_Size,
    };
    setState((prev) => ({ ...prev, hasMore: false, filterParams }));
    dispatch(action.updateTotalCount());
    const res = await dispatch(action.getAllUsageProducts(params));
    res && setLoading(false);
  };

  const cat2Ids = () => {
    return selectedCategory2 ? selectedCategory2._id : '';
  };
  const cat3Ids = () => {
    return selectedCategory3 ? selectedCategory3._id : '';
  };
  const cat1Ids = () => {
    return selectedCategory1 ? selectedCategory1._id : '';
  };

  const forLibFilter = async (val, eve) => {
    switch (val) {
      case 'op1':
        setSelectedBrand(eve);
        break;
      case 'op2':
        setSelectedSeason(eve);
        break;
      case 'op3':
        setSelectedYear(eve);
        break;
      case 'op4':
        setSelectedMonth(eve);
        break;
      case 'op5':
        setSelectedSupplier(eve);
        break;
      case 'op6':
        setSelectedStatus(eve);
        break;
      case 'op7':
        setSelectedCategory1(eve);
        ForCategoryThree(eve ? eve._id : '', cat2Ids());
        ForCategoryFour(eve ? eve._id : '', cat2Ids(), cat3Ids());
        break;
      case 'op8':
        setSelectedCategory2(eve);
        ForCategoryThree(cat1Ids(), eve ? eve._id : '');
        ForCategoryFour(eve ? eve._id : '', cat1Ids(), cat3Ids());

        break;
      case 'op9':
        setSelectedCategory3(eve);
        ForCategoryFour(cat1Ids(), cat2Ids(), eve ? eve._id : '');

        break;
      case 'op10':
        setSelectedCategory4(eve);
        break;
      case 'op11':
        setSelectedColourWay(eve);
        break;
      case 'op12':
        setSelectedColour(eve);
        break;
      case 'clear':
        setSelectedBrand(null);
        setSelectedSeason(null);
        setSelectedYear(null);
        setSelectedMonth(null);
        setSelectedSupplier(null);
        setSelectedStatus(null);
        setSelectedCategory1(null);
        setSelectedCategory2(null);
        setSelectedCategory3(null);
        setSelectedCategory4(null);
        setSelectedColourWay(null);
        setSelectedColour(null);
        onSubmitFilter();
        break;

      default:
        // eslint-disable-next-line no-case-declarations
        const paramsforfilter = {
          brandId: selectedBrand?._id,
          seasonId: selectedSeason?._id,
          year: selectedYear?.name,
          month: selectedMonth?._id,
          supplierId: selectedSupplier?._id,
          status: selectedStatus?._id,
          catOneId: selectedCategory1?._id,
          catTwoId: selectedCategory2?._id,
          catThreeId: selectedCategory3?._id,
          catFourId: selectedCategory4?._id,
          colourwayId: selectedColourWay?._id,
          colourwayIdName: selectedColour?._id,
        };
        onSubmitFilter(paramsforfilter);
        break;
    }
  };

  const showFilters = () => {
    return (
      <FilterBy
        onBtnClick={forLibFilter}
        placeholder={t('COSTING_TO_DO_LIST.SELECT_BRAND')}
        noOption={t('FILTER.NO_BRAND_DATA_AVAILBLE')}
        placeholder2={t('COSTING_TO_DO_LIST.SELECT_SEASON')}
        noOption2={t('FILTER.NO_SEASON_DATA_AVAILBLE')}
        placeholder3={t('COSTING_TO_DO_LIST.SELECT_YEAR')}
        noOption3={t('FILTER.NO_YEAR_AVAILBLLE')}
        placeholder4={t('PROGRESS_INDICATOR.SELECT_MONTH')}
        noOption4={t('FILTER.NO_MONTHS_AVAILBLE')}
        placeholder5={t('FILTER.SELECT_PRODUCT_SUPLIER')}
        noOption5={t('FILTER.NO_PRODUCT_SUPLIER')}
        placeholder6={t('PROGRESS_INDICATOR.SELECT_STATUS')}
        noOption6={t('FILTER.NO_STATUS_AVAILBLE')}
        placeholder7={t('COSTING_TO_DO_LIST.SELECT_CATEGORY_1')}
        noOption7={t('TAKING_DATES.NO_CATEGEROY_AVAILBLE')}
        placeholder8={t('COSTING_TO_DO_LIST.SELECT_CATEGORY_2')}
        noOption8={t('FILTER.NO_CATEGORY2_AVAILBLE')}
        placeholder9={t('SPEC_TEMP_LIBRARY.CATEGORY3_PLACEHOLDER')}
        noOption9={t('FILTER.NO_CATEGORY3_AVAILBLE')}
        placeholder10={t('COSTING_TO_DO_LIST.SELECT_CATEGORY_4')}
        noOption10={t('FILTER.NO_CATEGORY4_AVAILBLE')}
        colourwayPlaceholder={t('FILTER.SELECT_COLOURWAY_REF')}
        colourwayNoOption={t('FILTER.NO_COLOURWAY_REF_AVAILBLE')}
        colourRefPlaceholder={t('FILTER.SELECT_COLOUR_REF')}
        colourRefNoOption={t('FILTER.NO_COLOUR_REF_AVAILBLE')}
        selectedItem1={selectedBrand}
        selectedItem2={selectedSeason}
        selectedItem3={selectedYear}
        selectedItem4={selectedMonth}
        selectedItem5={selectedSupplier}
        selectedItem6={selectedStatus}
        selectedItem7={selectedCategory1}
        selectedItem8={selectedCategory2}
        selectedItem9={selectedCategory3}
        selectedItem10={selectedCategory4}
        selectedColourWay={selectedColourWay}
        selectedColour={selectedColour}
      />
    );
  };

  const forExpandData = (ele) => {
    if (ele.expandData?.length) {
      return ele.expandData.map((obj) => obj?.idPlusSupplierId);
    }
    return [ele?.idPlusSupplierId || ele?._id];
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of allProducts) {
        let findItems = [];
        findItems = ifMoreSuppliers(item, selectedItems);
        if (isEmpty(findItems)) {
          selectedItems.push(...forExpandData(item));
        }
      }
      setSelectedIdArray([...selectedItems]);
    }
    setIsSelectAll(!isSelectAll);
  };

  const ifMoreSuppliers = (item, selectedItems) => {
    if (item?.suppliers?.length === 1) {
      return selectedItems.filter((val) => val === item.idPlusSupplierId);
    }
    const ids = forExpandData(item);
    ids.forEach((ele) => {
      return selectedItems?.filter((val) => val === ele);
    });
  };

  const iconsChange = () => {
    return sortTable.sortOrder === '' ? <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" /> : forAscandDesc();
  };

  const forAscandDesc = () => {
    return sortTable.sortOrder === 'Asc' || sortTable.sortOrder === '' || sortTable.sortOrder === 'asc' ? (
      <i className="icon-Table-Down font-weight-heavy  f-14 text-black ml-1" />
    ) : (
      <i className="icon-Table-Up font-weight-heavy f-14 text-black ml-1" />
    );
  };

  const ifSortingSupplier = (sortBy) => {
    if (sortBy.sortOrder === 'Desc') sortBy.sortOrder = 'desc';
    if (sortBy.sortOrder === 'Asc') sortBy.sortOrder = 'asc';
    if (count !== 0) {
      if (!isEmpty(indexes)) {
        indexes.forEach((ele) => {
          const updatedArr = orderBy(allProducts[ele].suppliers, 'name', sortBy?.sortOrder);
          allProducts[ele].suppliers = updatedArr;
          allProducts[ele].isExpanded = true;
          setSortedData([...allProducts]);
        });
      }
    } else {
      allProducts.forEach((obj) => {
        const updatedArr = orderBy(obj.suppliers, 'name', sortBy?.sortOrder);
        obj.suppliers = updatedArr;
        setSortedData([...allProducts]);
      });
    }
  };

  const ifSortingCompSupplier = (sortBy) => {
    if (sortBy.sortOrder === 'Desc') sortBy.sortOrder = 'desc';
    if (sortBy.sortOrder === 'Asc') sortBy.sortOrder = 'asc';
    if (count !== 0) {
      if (!isEmpty(indexes)) {
        indexes.forEach((ele) => {
          const updatedArr = orderBy(allProducts[ele].componentSupplier, 'name', sortBy?.sortOrder);
          allProducts[ele].componentSupplier = updatedArr;
          allProducts[ele].isExpanded = true;
          setSortedData([...allProducts]);
        });
      }
    } else {
      allProducts.forEach((obj) => {
        const updatedArr = orderBy(obj.componentSupplier, 'name', sortBy?.sortOrder);
        obj.componentSupplier = updatedArr;
        setSortedData([...allProducts]);
      });
    }
  };

  const ifSortingColourWay = (sortBy) => {
    if (sortBy.sortOrder === 'Desc') sortBy.sortOrder = 'desc';
    if (sortBy.sortOrder === 'Asc') sortBy.sortOrder = 'asc';
    if (count !== 0) {
      if (!isEmpty(indexes)) {
        indexes.forEach((ele) => {
          const updatedArr = orderBy(allProducts[ele].colourLibraries, 'name', sortBy?.sortOrder);
          allProducts[ele].colourLibraries = updatedArr;
          allProducts[ele].isExpanded = true;
          setSortedData([...allProducts]);
        });
      }
    } else {
      allProducts.forEach((obj) => {
        const updatedArr = orderBy(obj.colourLibraries, 'name', sortBy?.sortOrder);
        obj.colourLibraries = updatedArr;
        setSortedData([...allProducts]);
      });
    }
  };

  const onSortColumn = async (e) => {
    let sortBy = {};
    if (sortTable.sortOrder === '' || sortTable.sortOrder === 'Desc' || sortTable.sortOrder === 'desc' || sortTable.propertyName !== e) {
      sortBy = {
        sortOrder: 'Asc',
        propertyName: e,
        searchText: search,
      };
      setSortTable(sortBy);
    } else {
      sortBy = {
        sortOrder: 'Desc',
        propertyName: e,
        searchText: search,
      };
      setSortTable(sortBy);
    }
    const params = {
      bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: !!fromBomLib,
      ...sortBy,
      pageIndex: 1,
      pageSize: Page_Size,
    };
    if (e === 'suppliers') {
      ifSortingSupplier(sortBy);
    } else if (e === 'colourWay') {
      ifSortingColourWay(sortBy);
    } else if (e === 'ComponentSuppliers') {
      ifSortingCompSupplier(sortBy);
    } else {
      setState((prev) => ({ ...prev, hasMore: false, sortBy }));
      dispatch(action.updateTotalCount());
      dispatch(action.getAllUsageProducts(params));
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setSearchLoaded(true);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchLoaded) {
        setSelectedIdArray([]);
        setIsSelectAll(false);
        setLoading(true);
        const params = {
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          searchText: search,
          pageIndex: 1,
          pageSize: Page_Size,
        };
        setState((prev) => ({ ...prev, hasMore: false, search }));
        dispatch(action.updateTotalCount());
        const res = dispatch(action.getAllUsageProducts(params));
        res && setLoading(false);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const addNewProduct = async () => {
    setIsProductFilter(true);
  };

  const handlenewRow = async (devIds) => {
    if (checkArray(devIds)) {
      const params = {
        devOrderId: devIds,
        bomComponentId: showData?._id,
      };
      if (fromBomLib) {
        params.isBomLibrary = true;
      }
      setDisabledBtn(true);
      const resUsaage = await dispatch(action.saveUsageProducts(params, t));
      if (resUsaage) {
        setDisabledBtn(false);
        setShowNewRow(false);
        handleClose();
        const getparams = {
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          pageIndex: 1,
          pageSize: Page_Size,
        };
        setState((prev) => ({ ...prev, hasMore: false }));
        dispatch(action.updateTotalCount());
        const res = dispatch(action.getAllUsageProducts(getparams));
        res && setLoading(false);
      }
    } else {
      toasterMsg('Select at least one product.', 'danger');
    }
  };

  const handleCancle = () => {
    setShowNewRow(false);
  };

  const onSelectCheckBox = async (e, id) => {
    let totalCount = 0;
    let listCount = 0;
    let selectedItems = [...selectedIdArray];
    if (e.target.checked) {
      setSelectedIdArray([...selectedItems, id]);
      allProducts.forEach((ele) => {
        if (ele?.expandData?.length === 1) {
          if (ele.idPlusSupplierId === id) {
            totalCount += 1;
          }
        } else if (!isEmpty(ele.expandData)) {
          listCount += ele?.expandData?.length;
          ele?.expandData?.forEach((item) => {
            item.idPlusSupplierId === id && (totalCount += 1);
          });
        }
      });
      selectedItems?.length + 2 === allProducts?.length + listCount && setIsSelectAll(true);
    } else {
      setIsSelectAll(false);
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    }
  };

  const forSuppSave = () => {
    const finalArr = [];
    showData?.suppliers?.forEach((obj) => {
      finalArr.push(obj._id);
    });
    return finalArr;
  };

  const forBOMApproval = () => {
    const approvalData = [];
    showData?.bomApprovals?.forEach((ele) => {
      const obj = {};
      obj.comment = ele?.comment;
      obj.commentDate = ele?.commentDate;
      obj.status = ele?.status;
      obj.supplierId = ele?.supplierId?._id;
      obj.approveBy = ele?.approveById;
      approvalData.push(obj);
    });
    return approvalData;
  };

  const forWeights = () => {
    return showData?.weight ? showData?.weight : '';
  };

  const forCompoSave = () => {
    const finalArr = [];
    showData?.composition?.forEach((obj) => {
      if (typeof obj === 'string') {
        // Handle string format like "50%Cotton"
        const CompositionNameArray = Composition.filter((compArrEle) => compArrEle.name.trim() === obj?.split('%')[1]?.trim());
        finalArr.push({
          percentage: obj?.split('%')?.[0],
          composition: CompositionNameArray?.[0]?._id,
        });
      } else if (typeof obj === 'object' && obj?.percentage && obj?.composition) {
        // Handle object format with percentage and composition properties
        finalArr.push({
          percentage: obj?.percentage,
          composition: obj?.composition?._id,
        });
      }
    });
    return finalArr;
  };
  // changes KJ
  const forColourRefData = () => {
    const ColourData = [];
    showData?.colourWayRefsData?.forEach((ele) => {
      const obj = {};
      obj._id = ele?._id;
      const newColourWay = [];
      ele?.colourRefsDataAsPerSuppliers?.forEach((col) => {
        const objsss = {
          ...col,
          colourRef: col?.colourRef?._id,
          approveBy: col?.approveBy?._id,
          tier1Supplier: col?.tier1Supplier?._id,
          componentSupplier: col?.componentSupplier?._id,
          colourRefName: col?.colourRefName?._id,
        };
        newColourWay.push(objsss);
      });
      obj.colourRefsDataAsPerSuppliers = newColourWay;
      obj.colourWayId = ele?.colourWayId?._id;
      obj.supplierList = ele?.supplierList;
      ColourData.push(obj);
    });
    return ColourData;
  };

  const ifUniqId = (obj, ele, ids) => {
    if (obj?.idPlusSupplierId === ele?.idPlusSupplierId) {
      ids.push({
        productd: ele?._id,
        productId: ele?._id,
        supplierId: ele?.suppliers?.[0]?._id,
        colourId: ele.colourLibraries?.[0]?._id,
      });
    } else {
      ele.expandData.forEach((object) => {
        if (object?.idPlusSupplierId === obj?.idPlusSupplierId) {
          ids.push({
            productId: object?._id,
            supplierId: object?.supplier?.[0]?._id,
            colourId: object.colour?.[0]?._id,
          });
        }
      });
    }
  };

  const fromIfChar = (obj) => {
    const ids = [];
    allProducts?.forEach((ele) => {
      if (ele?._id === obj?._id) {
        ifUniqId(obj, ele, ids);
      }
    });
    return {
      products: [...ids],
      bomType: showData?.bomType?._id,
      bomId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: fromBomLib,
    };
  };

  const inexpandedData = (ele, element, prodIds) => {
    return ele?.expandData?.forEach((obj) => {
      if (obj?.idPlusSupplierId === element) {
        prodIds.push({
          productId: obj?._id,
          supplierId: obj?.supplier?.[0]?._id,
          colourId: obj.colour?.[0]?._id,
        });
      }
    });
  };

  const forElseChar = () => {
    const prodIds = [];
    allProducts?.forEach((ele) => {
      selectedIdArray?.forEach((element) => {
        if (ele?.idPlusSupplierId === element) {
          const objectCaseHandler = typeof ele?.suppliers === 'object' ? ele?.suppliers?._id : null;
          const colourObjectHandler = typeof ele?.colourLibraries === 'object' ? ele?.colourLibraries?._id : null;
          prodIds.push({
            productId: ele?._id,
            productd: ele?._id,
            supplierId: Array.isArray(ele?.suppliers) ? ele?.suppliers?.[0]?._id : objectCaseHandler,
            colourId: Array.isArray(ele?.colourLibraries) ? ele?.colourLibraries?.[0]?._id : colourObjectHandler,
          });
        } else {
          inexpandedData(ele, element, prodIds);
        }
      });
    });

    return {
      products: [...prodIds],
      bomType: showData?.bomType?._id,
      bomId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: fromBomLib,
    };
  };

  const hanldeUpdate = async (ele) => {
    let params = {};

    if (ele !== null) {
      params = fromIfChar(ele);
    } else {
      params = forElseChar();
    }
    if (params?.products?.length > 0) {
      params.library = {
        // BOMSupplier: forBOMSupplier(),
        subBomList: showData?.subBomList ? showData?.subBomList : [],
        subBOMSwitch: showData?.subBOMSwitch ? showData?.subBOMSwitch : false,
        additionalInfo: showData?.additionalInfo ? showData?.additionalInfo : '',
        bomDescription: showData?.bomDescription ? showData?.bomDescription : '',
        bomType: showData?.bomType?._id ? showData?.bomType?._id : null,
        bomSubType: showData?.bomSubType?._id,
        colorAutoApprove: showData?.colorAutoApprove,
        colourWayRefsData: forColourRefData(),
        composition: forCompoSave(),
        devOrderId: showData?.devOrderId ? showData?.devOrderId : null,
        libId: showData?.libId ? showData?.libId : null,
        placement: forPlacments(),
        qualityAutoApprove: showData?.qualityAutoApprove,
        quantity: showData?.quantity || '',
        quantityUnitOfMeasure: forQtyUOM(),
        quality: showData?.quality || null,
        transport: showData?.transport || null,
        referenceCode: showData?.referenceCode,
        size: showData?.size ? showData?.size : '',
        sizeUnitOfMeasure: forsizeUOM(),
        suppliers: forSuppSave(),
        weight: forWeights(),
        weightUnitOfMeasure: forweightUOM(),
        _id: showData?._id,
        bomApprovals: forBOMApproval(),
        // combinationSuppliers: showData?.combinationSuppliers || [],
        newPlacement: showData?.newPlacement || null,
        finished: showData?.finished || null,
        bomComponentSubType: showData?.bomComponentSubType || null,
        pricePerUnitCurrency: showData?.pricePerUnitCurrency,
        pricePerUnit: showData?.pricePerUnit,
      };
      params.productSupplierId = topSelectedSupplier?._id ? topSelectedSupplier?._id : null;
      params.componentSupplierId = topSelectedComponentSupplier?._id ? topSelectedComponentSupplier?._id : null;
      params.devOrderId = ele?._id;
      forColourSection(params);
      setLoading(true);
      const resUpdate = await dispatch(action.updateUsageProducts(params, t));
      if (resUpdate) {
        const getparams = {
          bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
          isBomLibrary: !!fromBomLib,
          pageIndex: 1,
          pageSize: Page_Size,
        };
        setIsSelectAll(false);
        setSelectedIdArray([]);
        setState((prev) => ({ ...prev, hasMore: false }));
        dispatch(action.updateTotalCount());
        const res = dispatch(action.getAllUsageProducts(getparams));
        res && setLoading(false);
      }
    } else {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.PRODUCT_ATTRIBUTES.ONE_PRODUCT'), 'danger');
    }
  };

  const forColourSection = (params) => {
    params.colourWayId = topSelectedColour?._id ? topSelectedColour?._id : '';
    params.colourRef = topcolourWayRefsData?.colourRef ? topcolourWayRefsData?.colourRef : '';
    params.colourConfirmationRef = topcolourWayRefsData?.colourConfirmationRef ? topcolourWayRefsData?.colourConfirmationRef : '';
  };

  const forPlacments = () => {
    return showData?.placement ? showData?.placement : '';
  };
  const forweightUOM = () => {
    return showData?.weightUnitOfMeasure?._id ? showData?.weightUnitOfMeasure?._id : '';
  };

  const forsizeUOM = () => {
    return showData?.sizeUnitOfMeasure?._id ? showData?.sizeUnitOfMeasure?._id : '';
  };

  const forQtyUOM = () => {
    return showData?.quantityUnitOfMeasure?._id ? showData?.quantityUnitOfMeasure?._id : '';
  };

  const handleDelete = async (id) => {
    if (id) {
      setDeleteId(id);
    }
    setShowDeleteConfirmationPopup(true);
  };

  const elseCaseInDelete = (params) => {
    const selectedIds = allProducts?.filter((item) => selectedIdArray?.some((el) => el?.includes(item?._id))).map((item) => item?._id);
    params.bomId = showData?.libId ? showData?.libId : showData?._id;
    params.productIds = [...selectedIds];
    params.isBomLibrary = !!fromBomLib;
    params.bomType = showData?.bomType?._id;
  };

  const confirmDelete = async () => {
    setLoading(true);
    const params = {};
    if (deleteId) {
      params.bomId = showData?.libId ? showData?.libId : showData?._id;
      params.productIds = [deleteId];
      params.isBomLibrary = !!fromBomLib;
      params.bomType = showData?.bomType?._id;
    } else {
      elseCaseInDelete(params);
    }
    dispatch(action.deleteUsageProducts(params, t));
    setIsSelectAll(false);
    setShowDeleteConfirmationPopup(!showDeleteConfirmationPopup);
    setDeleteId('');
    setSelectedIdArray([]);
    const getparams = {
      bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
      isBomLibrary: !!fromBomLib,
      pageIndex: 1,
      pageSize: Page_Size,
    };
    setState((prev) => ({ ...prev, hasMore: false }));
    dispatch(action.updateTotalCount());
    const res = await dispatch(action.getAllUsageProducts(getparams));
    res && setLoading(false);
    checkisListEmpty(res);
  };

  const checkisListEmpty = (res) => {
    if (isEmpty(res)) toggleProdReq();
  };

  const setTopColour = (e) => {
    settopSelectedColour(e);
  };
  const setTopSupplier = (e) => {
    settopSelectedSupplier(e);
  };

  const setTopCompSupplier = (e) => {
    settopSelectedComponentSupplier(e);
  };

  const expandAllData = () => {
    const copyState = [...allProducts];
    const copies = [];
    const elements = [];
    if (isEmpty(indexes)) {
      copyState.forEach((ele, index) => {
        if (ele?.expandData?.length > 1) {
          copies.push(index);
          elements.push(ele.expandData?.[0].idPlusSupplierId);
          (ele.isExpanded === false || !ele.isExpanded) && (ele.isExpanded = true);
        }
      });
      setIndexes([...copies]);
      setParentIndexes([...elements]);
    } else {
      copyState.forEach((ele, index) => {
        if (ele?.expandData?.length > 1) {
          copies.push(index);
          if (ele.isExpanded === true) {
            ele.isExpanded = false;
          }
        }
      });
      setIndexes([]);
      setParentIndexes([]);
    }
  };

  const handleExpand = (index, spliceIndex) => {
    const copyState = [...allProducts];
    const copyParentState = [...parentIndexes];
    const copyindexState = [...indexes];
    if (indexes.includes(index)) {
      copyindexState.splice(spliceIndex, 1);
      copyParentState.splice(spliceIndex, 1);
      setParentIndexes([...copyParentState]);
      setIndexes([...copyindexState]);
      copyState[index].isExpanded = false;
    } else {
      copyState[index].isExpanded = !copyState[index]?.isExpanded;
      setIndexes([...indexes, index]);
      setParentIndexes([...parentIndexes, copyState[index].expandData?.[0].idPlusSupplierId]);
    }
    setSortTable({
      sortOrder: '',
      sortPropertyName: '',
    });
    setAllProducts([...copyState]);
  };

  const onAddProduct = (data) => {
    handlenewRow(data);
  };
  const handleClose = () => {
    setIsProductFilter(false);
    setDisabledBtn(false);
  };

  const handlePageNextInScroll = async () => {
    let index = state?.pageIndex;
    index += 1;
    setState((prev) => ({ ...prev, isScrollLoader: true }));
    const res = await dispatch(
      action.getAllUsageProducts({
        bomComponentLibId: showData?.libId ? showData?.libId : showData?._id,
        isBomLibrary: !!fromBomLib,
        pageIndex: index,
        pageSize: Page_Size,
        searchText: search,
        isScrolled: true,
        brandId: selectedBrand?._id,
        seasonId: selectedSeason?._id,
        year: selectedYear?.name,
        month: selectedMonth?._id,
        supplierId: selectedSupplier?._id,
        status: selectedStatus?._id,
        catOneId: selectedCategory1?._id,
        catTwoId: selectedCategory2?._id,
        catThreeId: selectedCategory3?._id,
        catFourId: selectedCategory4?._id,
      }),
    );
    if (res) {
      setState((prev) => ({ ...prev, pageIndex: index, isScrollLoader: false }));
    }
  };
  useEffect(() => {
    if (totalcount > allProducts?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [allProducts?.length, totalcount]);

  const handleDownload = async () => {
    if (fromBomLib) {
      await dispatch(
        action.downloadBomAttribute(
          {
            bomName: showDatas?.referenceCode,
            bomComponentLibId: showDatas?.libId ? showDatas?.libId : showDatas?._id,
            isBomLibrary: true,
            searchText: state?.search || '',
            ...state?.filterParams,
            sortOrder: state?.sortBy,
          },
          t,
        ),
      );
    } else {
      await dispatch(
        action.downloadBomAttribute(
          {
            bomName: showDatas?.referenceCode,
            devOrderId: showDatas?.devOrderId,
            bomComponentLibId: showDatas?.libId ? showDatas?.libId : showDatas?._id,
            isBomLibrary: false,
            searchText: state?.search || '',
            ...state?.filterParams,
            sortOrder: state?.sortBy,
          },
          t,
        ),
      );
    }
  };

  return (
    <>
      <Modal
        className="relative-width-modal product-attribute-modal custom-modal modal-medium-4x supplier-overview-modal color-way-modal moda-fullpage"
        size="lg"
        show={onOpen}
        onHide={toggleProdReq}
        backdrop="static"
        centered
      >
        <Modal.Header className="product-attribute-header">
          <Modal.Title className="product-attribute-title">{t('FILTER.PRODUCT_ATTRIBUTES')}</Modal.Title>
          <span onClick={() => toggleProdReq()} className="icon-close f-20 cursor-pointer" />
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="bom-list mb-3">
                <TopProductAttributeTable
                  showData={showData}
                  fromBomLib={fromBomLib}
                  setTopColour={setTopColour}
                  setTopSupplier={setTopSupplier}
                  setTopCompSupplier={setTopCompSupplier}
                  setTopColourWayrefData={setTopColourWayrefData}
                  devOrderId={showData?.devOrderId}
                  setstate={setState}
                />
                <div className="filter-container modal-search mb-3 mt-3">
                  <div className="title-search-container bom-search-sm pl-0">
                    <input
                      onChange={(e) => handleSearch(e)}
                      name="search"
                      type="text"
                      value={search}
                      className="form-control text-bordered product-bom-input"
                      placeholder={t('TAKING_DATES.SEACH')}
                    />
                  </div>
                  <CustomTooltip placement="top" tooltipText={t('FILTER.ADD_NEW_PRODUCT')}>
                    <button className="btn product-bom-icon" type="button" aria-label={t('FILTER.ADD_NEW_PRODUCT')} onClick={addNewProduct}>
                      <i className="icon-Add" />
                    </button>
                  </CustomTooltip>

                  <span className="" title={t('FILTER.FILTERS')}>
                    {showFilters()}
                  </span>
                  <CustomTooltip placement="top" tooltipText={t('FILTER.UPDATE')}>
                    <button
                      className="btn product-bom-icon"
                      type="button"
                      aria-label={t('FILTER.UPDATE')}
                      onClick={() => hanldeUpdate(null)}
                      disabled={isEmpty(selectedIdArray)}
                    >
                      <i className="icon-Update-1 f-22" />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip placement="top" tooltipText={t('FILTER.DOWNLOAD')}>
                    <button
                      className="btn product-bom-icon"
                      type="button"
                      onClick={handleDownload}
                      aria-label={t('FILTER.DOWNLOAD')}
                      disabled={isEmpty(allProducts)}
                    >
                      <i className="icon-Download1 f-22" />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                    <button
                      className="btn product-bom-icon"
                      type="button"
                      aria-label={t('FILTER.DELETE')}
                      onClick={() => handleDelete(null)}
                      disabled={isEmpty(selectedIdArray)}
                    >
                      <i className="icon-Delete" />
                    </button>
                  </CustomTooltip>
                </div>
              </div>
              <div className="mt-3">
                <BottomProductAttributesTable
                  handleSelectAll={handleSelectAll}
                  isLoading={loading}
                  isSelectAll={isSelectAll}
                  allImportedProducts={allProducts}
                  onSortColumn={onSortColumn}
                  sortTable={sortTable}
                  iconsChange={iconsChange}
                  showNewRow={showNewRow}
                  addNewProduct={handlenewRow}
                  handleCancle={handleCancle}
                  onSelectCheckBox={onSelectCheckBox}
                  selectedIdArray={selectedIdArray}
                  hanldeUpdate={hanldeUpdate}
                  handleDelete={handleDelete}
                  productRefs={productRefs}
                  expandGrandTotalChild={handleExpand}
                  expandAllData={expandAllData}
                  indexes={indexes}
                  parentIndexes={parentIndexes}
                  count={count}
                  isScrollLoader={state?.isScrollLoader}
                  handlePageNextInScroll={handlePageNextInScroll}
                  hasMore={state?.hasMore}
                  subbrandAccess={subBrandAccess}
                />
              </div>
            </>
          )}
          {showDeleteConfirmationPopup && (
            <DeletePopup
              onOpen={showDeleteConfirmationPopup}
              onConfirm={confirmDelete}
              loading={loading}
              title={t('FILTER.DELETE_PRODUCT')}
              message={t('FILTER.ARE_U_SURE_DELETE')}
              secondMessage={t('FILTER.BOM_COMPONENTS')}
              toggle={() => setShowDeleteConfirmationPopup(!showDeleteConfirmationPopup)}
              showCheckBox
            />
          )}
        </Modal.Body>
      </Modal>
      {isProductFilter && (
        <ProductFilter products={productRefs} show={isProductFilter} onAddProduct={onAddProduct} handleClose={handleClose} disabledBtn={disabledBtn} />
      )}
    </>
  );
}

export default ProductAttributes;
